import React from 'react'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import Button from '@node-space/storybook-components/dist/Button'
import { PopoverPlacement } from '@node-space/storybook-components/dist/components/PopoverMenu/types'
import { Icon as LegacyIcon } from '@node-space/storybook-components/dist/Icon'
import PopoverMenu from '@node-space/storybook-components/dist/PopoverMenu'
import { Avatar, Box, Highlight, Icon, Text } from '@node-space/ui-components'
import { PathNames } from 'constants/General'
import { CustomerStatus, CustomerStatusType } from 'types/customers'
import { StatusLabelMapping, StatusMapping } from '../constants'

interface CustomerListItemProps {
  index?: number
  activeRowId?: number
  customerId?: string
  name: string
  description: string
  status?: CustomerStatusType
  setIsCustomerOpen?: (isOpen: boolean) => void
  updateCustomer?: (index: number) => void
}

const CustomerListItem = ({
  index,
  activeRowId,
  customerId,
  description,
  name,
  status,
  setIsCustomerOpen,
  updateCustomer,
}: CustomerListItemProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const isCustomerVerified = status === CustomerStatus.VERIFIED

  const activeRow = clsx('cursor-pointer hover:bg-lighterBlueTint', {
    'bg-secondary-50': activeRowId && activeRowId?.toString() === customerId,
  })

  const onRowClick = (customerId: string) => {
    navigate(`${PathNames.CUSTOMERS}/${customerId}`)
  }

  const onDetailsClick = () => {
    updateCustomer(index)
    setIsCustomerOpen(true)
  }

  return (
    <Box
      key={customerId}
      flex
      align="center"
      paddingX={16}
      paddingY={12}
      gapX={16}
      className={activeRow}
    >
      <Box
        width="full"
        flex
        onClick={() => {
          isCustomerVerified && onRowClick(customerId)
        }}
      >
        {name && <Avatar size="large" type="entity" name={name?.charAt(0)?.toUpperCase()} />}
        <Box flex flexCol flexSize="fill" paddingL={12} gapY={4}>
          <Text variant="body-label" className="leading-5">
            {name}
          </Text>
          <Text colour="subdued" className="leading-5">
            {description}
          </Text>
        </Box>
        {!isCustomerVerified && (
          <Box justify="center" align="center" flex paddingR={32}>
            <Highlight type={StatusMapping[status]} variant="status">
              {StatusLabelMapping[status]}
            </Highlight>
          </Box>
        )}
      </Box>
      <Box flex gapX={12}>
        <PopoverMenu
          menuItems={[
            {
              item: (
                <Button
                  testid="customers-details-btn"
                  noStyling
                  name={t('customers.details')}
                  iconElement={<Icon name="Info" />}
                >
                  {t('customers.details')}
                </Button>
              ),
              onClick: () => onDetailsClick(),
            },
          ]}
          placement={'bottomRight' as PopoverPlacement}
          hoverClass="cursor-pointer"
        >
          <LegacyIcon color="grey-08" name="MeatballIcon" />
        </PopoverMenu>
      </Box>
    </Box>
  )
}

export default CustomerListItem
